/* eslint-disable @nx/enforce-module-boundaries */
import { useEffect, type PropsWithChildren } from 'react';
import React from 'react';

import { FLAG_MAINTENANCE_MODAL } from '@shared/constants';
import { useLaunchDarklyWebClient } from '@shared/providers';

import { useMaintenanceModal } from './useMaintenanceModal';

const MaintenanceModeWeb = ({ children }: PropsWithChildren) => {
  const toggleMaintenanceModal = useMaintenanceModal();

  const ldClientWeb = useLaunchDarklyWebClient();

  useEffect(() => {
    const eventType = `change:${FLAG_MAINTENANCE_MODAL}`;

    ldClientWeb.waitForInitialization().then(() => {
      const showMaintenanceModal = ldClientWeb.variation(
        FLAG_MAINTENANCE_MODAL,
        false,
      );

      toggleMaintenanceModal(showMaintenanceModal);
    });

    ldClientWeb.on(eventType, (value) => {
      toggleMaintenanceModal(value);
    });

    return () => {
      ldClientWeb.off(eventType, () => {
        console.log(`${eventType} listener removed`);
      });
    };
  }, [toggleMaintenanceModal, ldClientWeb]);

  return <>{children}</>;
};

export { MaintenanceModeWeb };
